/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it
import "./src/styles/global.css"

import React from "react"
import { HelmetProvider } from "react-helmet-async"
import { TrafficTracker } from "./src/components/Shared/TrafficTracker"

export const wrapRootElement = ({ element }) => (
	<HelmetProvider>
		<TrafficTracker />
		{element}
	</HelmetProvider>
)